import { ELkType } from '../../types/lkType';
import { IApplicationState } from '../../types/redux';

export function selectShouldShowNewPlacementText(state: IApplicationState): boolean {
  if (!state.user.isAuthenticated) {
    return true;
  }

  return state.user.userType === ELkType.Searcher;
}
